<template>
  <div>
    <div class="head">
        Panasonic
    </div>
    <div class="title">
        <span>松下开关插座</span>
        <span class="title-weight">防伪查询平台</span>
    </div>
    <div class="security">
      <p>{{model.message}}</p>
    </div>
  </div>
</template>

 <style lang="scss" >
@import "../static/css/panasonic/common.css";
@import "../static/css/panasonic/index.css";
.bottom {
  position: fixed;
}
</style>
<script>
import { getQueryFirst } from "@/js/tool.js";
import api from "../webapi/queryApi";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      model: {
        message: ""
      }
    };
  },
  created() {
    this.model.message = JSON.parse(window.localStorage['ccn_querycoderesult']);//getHashParameters().message;    
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
};
</script>

<style scoped>
</style>